import * as companyActionTypes from '../types/Company';
import {HIDE_MODAL} from '../types/Modal';
import {INITIAL_STATE} from './state/Company';
import {PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE,PAGE_GO_TO_START_PAGE, PAGE_GO_TO_CREATE_COMPLAINT_PAGE} from '../types/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case companyActionTypes.COMPANY_CHANGE_SELECTED_ROW:
            return { 
                ...state,
                selectedRow:action.payload,
                isRowSelected:true
            };
        case companyActionTypes.COMPANY_CHANGE_TABLE_PAGE:
            return{
                ...state,
                tablePage: action.payload
            }; 
        case companyActionTypes.COMPANY_CHANGE_TEXT_FOR_SEARCHING:
            return {
                ...state,
                textForSearching: action.payload
            };
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TAX_FAILURE:
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TEXT_FAILURE:
            return { 
                ...state,
                isLoading:false
            };
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TAX_REQUEST:
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TEXT_REQUEST:
            return { 
                ...state, 
                companies:[],
                isLoading:true,
                isRowSelected:false
                
            };
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TAX_SUCCESS:
        case companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TEXT_SUCCESS:
            return { ...state, 
                companies: action.payload,
                isLoading:false
            };
        case PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case PAGE_GO_TO_START_PAGE: 
        case PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Company.js